<template>
  <div>
    <i class="fa fa-check text-success"></i>
    Commercial gepromoot via commercialreview kanalen:

    <div class="pl-3">
      <small>
        <i class="fa fa-dot-circle mr-2 fa-xs text-success"></i>
        <a href="https://www.linkedin.com/company/commercialreview/" target="_blank">
          LinkedIn
        </a>(2200+ volgers)
      </small>
    </div>
    <div class="pl-3">
      <small>
        <i class="fa fa-dot-circle mr-2 fa-xs text-success"></i>
        <a href="https://www.instagram.com/commercialreview.nl/" target="_blank">
          Instagram
        </a> (2700+ volgers)
      </small>
    </div>
    <div class="pl-3">
      <small>
        <i class="fa fa-dot-circle mr-2 fa-xs text-success"></i>
        Homepage
      </small>
    </div>
     <div class="pl-3">
      <small>
        <i class="fa fa-dot-circle mr-2 fa-xs text-success"></i>
        Nieuwsbrief (1600+ abonnees)
      </small>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CommercialPromoted',
};
</script>
